/*
 * WaWiKommiApp.tsx
 *
 * Created by Dr. Maximillian Dornseif 2021-11-27 in huWaWi3 24.5.4
 * Copyright (c) 2021-2023 HUDORA GmbH
 */

import {
  DefaultButton,
  Dialog,
  DialogFooter,
  Panel,
  PanelType,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
} from '@fluentui/react'
import { useDialog, usePanel } from 'fluentui-hooks'
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'
import React from 'react'
import toast from 'react-hot-toast'
import { useMutation, useQuery } from 'urql'
import { navigate } from 'wouter/use-location'

import { KOMMI_FRAGMENT } from '../fragments'
import { EntityPageInner3 } from '../lib/components/ke/EntityPageInner3'
import { EntityTable3 } from '../lib/components/ke/EntityTable3'
import { KindPage3 } from '../lib/components/ke/KindPage3'
import { DisplayH2Audit } from '../WaWi/components/H2Audit'
import { KOMMIAUDIT_QUERY, KOMMI_LIST_QUERY, KOMMI_QUERY } from './IcKommiAppQueries'

/** Rendert entweder die Startseite (Suche) oder eine Gruppenseite
 **/
export const IcKommiApp = (props) => {
  const renderEntityPage = (entity) => {
    return <EntityERP entity={entity} />
  }

  return (
    <KindPage3
      basePath={'/ic'}
      componentPath={'kommi'}
      schemaName={'HwKommiAuftrag2'}
      title={'Offene Kommi Auftraege'}
      // suggestionQuery={}
      listQuery={KOMMI_LIST_QUERY}
      entityQuery={KOMMI_QUERY}
      renderEntityPage={renderEntityPage}
    ></KindPage3>
  )
}

interface IDialogInnerProps {
  entity: Record<string, any>
  mutation: DocumentNode
  onDismiss: () => void
}
function EntityERP({ entity }) {
  const [openRueckDialog, rueckDialogProps, , rueckDismissDialog] = useDialog(
    'Kommi zurückmelden',
    `Soll der Kommiauftrag mit exakt den geforderten Mengen zurück gemeldet werden?`
  )
  const [openNullDialog, nullDialogProps, , nullDismissDialog] = useDialog(
    'Kommi nullen',
    `Soll der Kommiauftrag ohne Warenbewegung zurückgemeldet werden?
      Dadurch wird auch im Auftrag eine Zuteilungssperre gesetzt.`
  )
  const [openPdfPanel, pdfPanelProps, isPdfPanelOpen] = usePanel(`PDF`)
  const [result] = useQuery({
    query: gql`
      query KommiPDF($nr: ID!) {
        entity: hwKommiAuftrag2(designator: $nr) {
          ...kommiAuftragFragment
          belege {
            id
            _keyStr
            designator
            pdfUrl
          }
        }
      }
      ${KOMMI_FRAGMENT}
    `,
    variables: { nr: entity.designator },
  })
  const { data } = result
  const beleg = data?.entity?.belege.filter((x) => x.designator === entity.designator).pop()
  const [{ data: dataAudit }] = useQuery({ query: KOMMIAUDIT_QUERY, variables: { nr: entity.designator } })
  console.log(dataAudit)
  const auditLog = dataAudit?.entity?.nodes || []

  const entityCommandBarItems = [
    {
      key: 'rueckmelden',
      text: 'rueckmelden',
      ariaLabel: 'Beleg Rückmelden',
      iconProps: {
        iconName: 'MSNVideosSolid',
      },
      iconOnly: false,
      disabled: !(entity.status < '300'),
      onClick: (e) => {
        openRueckDialog()
      },
    },
    // {
    //   key: 'fehlmengen',
    //   text: 'fehlmengen',
    //   ariaLabel: 'mit Fehlmengen Rückmelden',
    //   iconProps: {
    //     iconName: 'CirclePause',
    //   },
    //   iconOnly: false,
    //   disabled: !(entity.status < '300'),
    //   // onClick: (e) => {
    //   //   navigate(window.location.pathname.replace('/eap/prod/', '/wawi/prod/'))
    //   // },
    // },
    {
      key: 'nullen',
      text: 'nullen',
      ariaLabel: 'Beleg Nullen',
      iconProps: {
        iconName: 'CircleStop',
      },
      iconOnly: false,
      disabled: !(entity.status < '300'),
      onClick: (e) => {
        openNullDialog()
      },
    },
    {
      key: 'pdf',
      text: 'PDF anzeigen',
      ariaLabel: 'PDF anzeigen',
      iconProps: { iconName: 'PDF' },
      onClick: openPdfPanel,
    },
    {
      key: 'belegpdf',
      text: 'Beleg Anzeigen',
      ariaLabel: 'Beleg Anzeigen',
      iconProps: { iconName: 'TextDocument' },
      onClick: (e) => navigate(`/belege/${entity.designator}`),
    },
  ]

  return (
    <>
      <EntityPageInner3
        entity={entity}
        schemaName={'HwKommiAuftrag2'}
        commandBarItems={entityCommandBarItems}
      />
      <DisplayPositionen entity={entity} />
      <DisplayH2Audit log={auditLog} />
      <Dialog {...rueckDialogProps}>
        <DialogInner
          entity={entity}
          onDismiss={rueckDismissDialog}
          mutation={gql`
            mutation KommiNullenMutation1($nr: ID!) {
              hwKommiAuftragRueckmelden(designator: $nr) {
                ...kommiAuftragFragment
              }
            }
            ${KOMMI_FRAGMENT}
          `}
        />
      </Dialog>
      <Dialog {...nullDialogProps}>
        <DialogInner
          entity={entity}
          onDismiss={nullDismissDialog}
          mutation={gql`
            mutation KommiNullenMutation2($nr: ID!) {
              hwKommiAuftragNullen(designator: $nr) {
                ...kommiAuftragFragment
              }
            }
            ${KOMMI_FRAGMENT}
          `}
        />
      </Dialog>
      <Panel {...pdfPanelProps} type={PanelType.large}>
        {isPdfPanelOpen ? (
          <div style={{ width: '100%', height: '100%' }}>
            <object data={beleg?.pdfUrl} type="application/pdf" width="100%" height="100%">
              <p>
                Scheinbar klappt das Einbetten nicht.Egal - <a href={beleg?.pdfUrl}>zum PDF!</a>
              </p>
            </object>
          </div>
        ) : null}
      </Panel>
    </>
  )
}

function DialogInner(props: IDialogInnerProps) {
  const [mutationResult, mutateEntity] = useMutation(props.mutation)
  const { fetching } = mutationResult

  // Daten per GraphQL Mutation an den Server senden.
  const uebertragen = async (e: never) => {
    const result = await mutateEntity({
      nr: props.entity.designator,
    } as any)
    if (result.error) {
      toast.error(`Fehler: ${result.error.message}`)
    } else {
      toast.success('Erfolgreich zurück gemeldet!')
    }
    props.onDismiss()
  }

  return (
    <>
      {props.entity.status > '200'
        ? 'Nur machen, wenn man sicher ist, die Ware auf jeden Fall vom Lager so versendet oder eben nicht versendet wird.'
        : null}
      <Separator></Separator>

      <DialogFooter>
        <PrimaryButton onClick={uebertragen} text="Zurückmelden" disabled={fetching}>
          {fetching ? <Spinner labelPosition="right" size={SpinnerSize.small} /> : null}
        </PrimaryButton>
        <DefaultButton onClick={props.onDismiss} text="Schießen" />
      </DialogFooter>
    </>
  )
}

function DisplayPositionen(props) {
  return (
    <EntityTable3
      title="Positionen"
      schemaName="HwKommiAuftragsPosition2"
      rowData={props.entity?.positionen}
    />
  )
}
